module.exports = __webpack_public_path__ + "static/img/scene9.f77606c3.png";